<template>
  <dropdown-menu-button direction="right" :loading="loading">
    <v-list>
      <v-list-item color="light" @click="editContact">
        <v-list-item-title>Edit</v-list-item-title>
      </v-list-item>
      <v-list-item color="light" @click="openContactPortal">
        <v-list-item-title>View Contact's Portal</v-list-item-title>
      </v-list-item>
      <v-list-item
        color="light"
        @click="removeContact"
        v-if="hasPermission('delete_contacts')"
      >
        <v-list-item-title>Delete</v-list-item-title>
      </v-list-item>
    </v-list>
  </dropdown-menu-button>
</template>

<script>
import { mapActions } from 'vuex';
import EventBus from '@/factories/eventBus';

export default {
  name: 'ContactControls',
  data() {
    return {
      loading: false,
    };
  },
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    contactId() {
      return this.contact?.con_id;
    },
    fullName() {
      const { first_name, last_name } = this.contact;
      if (!first_name && !last_name) return 'unknown';
      return `${first_name} ${last_name}`;
    },
  },
  methods: {
    ...mapActions(['deleteContact', 'archiveContact', 'loadSingleContact']),
    editContact() {
      this.$router.push({
        name: 'contact-edit',
        params: {
          id: this.contactId,
        },
      });
    },

    openContactPortal() {
      EventBus.$emit('openContactActionDialog', {
        contact: this.contact,
        modalType: 'portal',
      });
    },

    removeContact() {
      this.openConfirmationModal({
        title: 'Are you sure you want to delete?',
        text:
          '<p class="mb-2">You will lose all tasks, notes, messages, progress, etc. related to this contact. <strong>This cannot be undone.</strong></p> ' +
          `<p class="mb-0">Does it make sense to archive <strong>${this.fullName}</strong> instead? Archiving will keep the contact but disable all their access to your content.</p>`,
        alternativeButtonText: 'Archive',
        onAlternative: async () => {
          this.loading = true;
          try {
            await this.archiveContact(this.contactId);
            this.loadSingleContact(this.contactId);
          } finally {
            this.loading = false;
          }
        },
        onConfirm: () => {
          this.loading = true;
          this.deleteContact(this.contactId).then(() => {
            this.loading = false;
          });
        },
      });
    },
  },
};
</script>
